package com.swetdot.swetgram.data.shop

import com.swetdot.swetgram.data.api.ApiClient
import com.swetdot.swetgram.data.newUuid
import com.swetdot.swetgram.domain.XpShopCatalogDomain
import com.swetdot.swetgram.domain.XpShopCategoryDomain
import com.swetdot.swetgram.domain.XpShopItemDomain
import com.swetdot.swetgram.domain.XpShopPurchaseDomain
import com.swetdot.swetgram.protocol.dto.PurchaseShopItemRequest
import com.swetdot.swetgram.protocol.dto.PurchaseShopItemResponse
import com.swetdot.swetgram.protocol.dto.XpShopItem
import com.swetdot.swetgram.protocol.dto.XpShopItemList
import io.ktor.client.request.setBody

class XpShopRepository(
    private val api: ApiClient,
) {
    suspend fun getCatalog(): XpShopCatalogDomain {
        val response = api.get<XpShopItemList>("shop/items")
        return XpShopCatalogDomain(
            items = response.items.map(XpShopItem::toDomain),
            spendableXp = response.spendableXp,
            streakFreezes = response.streakFreezes,
        )
    }

    suspend fun getItems(): List<XpShopItemDomain> = getCatalog().items

    suspend fun purchase(itemCode: String): XpShopPurchaseDomain {
        val clientId = newUuid()
        val response = api.post<PurchaseShopItemResponse>(
            path = "shop/purchase",
            idempotencyKey = clientId,
        ) {
            setBody(PurchaseShopItemRequest(clientId = clientId, itemCode = itemCode))
        }
        return response.toDomain()
    }
}

private fun XpShopItem.toDomain() = XpShopItemDomain(
    code = code,
    category = XpShopCategoryDomain.fromWire(category),
    title = title,
    description = description,
    priceXp = priceXp,
    badgeIcon = badgeIcon,
    enabled = enabled,
    isOwned = isOwned,
)

private fun PurchaseShopItemResponse.toDomain() = XpShopPurchaseDomain(
    purchaseId = purchaseId,
    itemCode = itemCode,
    remainingXp = remainingXp,
    streakFreezes = streakFreezes,
)
